var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomedepotProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#ff7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5451"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.2583,51.54291l-7.44763,3.91321c-.85156.44745-1.38489,1.33014-1.38489,2.29211v12.68781c0,1.42999,1.15924,2.58923,2.58923,2.58923h14.89526c1.42999,0,2.58923-1.15924,2.58923-2.58923v-12.68781c0-.96198-.53333-1.84467-1.38495-2.29211l-7.44763-3.91321c-.75397-.39618-1.6546-.39618-2.40863,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.79364,36.43915l-5.6098-3.23877-18.48676,10.67346,6.79382,3.9223c.36646.21155.81793.21155,1.18439,0l16.11835-9.30554c.78961-.45587.78961-1.59558,0-2.05145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.37299,38.49066l5.13184,2.96283,18.48712-10.67334-6.31641-3.64679c-.36646-.21155-.81793-.21155-1.18439,0l-16.11823,9.30591c-.78955.45587-.78955,1.59552.00006,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.50049,43.08911v18.68835c0,.41119.21942.7912.57556.99677l16.18445,9.34412c.76733.44305,1.72656-.11072,1.72656-.99677v-18.68823c0-.41119-.21942-.7912-.5755-.99677l-6.87177-3.96753v9.87964l-4.19214-2.17682v-10.12317l-5.12061-2.95642c-.76733-.44305-1.72656.11072-1.72656.99683Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomedepotProductsScraper);
export default __webpack_public_path__ + "static/media/homedepot-products-scraper.a4e3a52a08a27bed1b40bada4a2afb9c.svg";
export { ForwardRef as ReactComponent };